export default __webpack_public_path__ + "static/logo.eglo-92c61c5d7da3ebad2340641e3b674f27.png";